import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { ThreadInformationProps } from '../partials/ThreadInformation';
import { PaginationItemWithPageLink, Pagination } from '../../../_lib/components/Pagination';
import { ThreadInformationList } from '../partials/ThreadInformationList';
import { useSonTranslation } from '../../../translation/useSonTranslation';

type ThreadListDefaultProps = {
  threads: ThreadInformationProps[];
  pageItems: PaginationItemWithPageLink[];
};

function ThreadListDefault({ threads, pageItems }: ThreadListDefaultProps) {
  const { t } = useSonTranslation('ThreadlistBlock');
  return (
    <div className="thread-list-block">
      {threads && threads.length > 0
        ? (
            <>
              <h2 className="invisible" id="thread-list-heading">
                {t('headline')}
              </h2>
              <ThreadInformationList threads={threads} />
              <Pagination key={threads.length} pageItems={pageItems} />
            </>
          )
        : (
            <p className="thread-list__no-threads">{t('nothingHere')}</p>
          )}
    </div>
  );
}

export const ThreadListDefaultView = asView(ThreadListDefault);
export type ThreadListDefaultView = ComponentProps<typeof ThreadListDefaultView>;
